module.exports = __webpack_public_path__ + "img/panel.d9f4c357.svg";